import { useEffect, useState, useRef } from 'react';
import '../styles/BannerPromociones.css';

const INTERVALO = 4000; // ms entre slides

export default function BannerPromociones() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);
  const [saliendo, setSaliendo] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    fetch('/api/promociones?activas=1')
      .then(r => r.json())
      .then(data => setItems(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, []);

  const avanzar = (siguiente) => {
    setSaliendo(true);
    setTimeout(() => {
      setIdx(siguiente);
      setSaliendo(false);
    }, 350);
  };

  useEffect(() => {
    if (items.length <= 1) return;
    timerRef.current = setInterval(() => {
      setIdx(prev => {
        const sig = (prev + 1) % items.length;
        setSaliendo(true);
        setTimeout(() => { setIdx(sig); setSaliendo(false); }, 350);
        return prev; // el setIdx real ocurre en el timeout
      });
    }, INTERVALO);
    return () => clearInterval(timerRef.current);
  }, [items]);

  if (items.length === 0) return null;

  const ir = (i) => {
    clearInterval(timerRef.current);
    avanzar(i);
  };

  return (
    <div className="bp-banner">
      <span className="bp-icono">★</span>
      <div className="bp-texto-wrap">
        <span className={`bp-texto${saliendo ? ' saliendo' : ''}`}>
          {items[idx]?.texto}
        </span>
      </div>
      {items.length > 1 && (
        <>
          <div className="bp-dots">
            {items.map((_, i) => (
              <button
                key={i}
                className={`bp-dot${i === idx ? ' activo' : ''}`}
                onClick={() => ir(i)}
                aria-label={`Promoción ${i + 1}`}
              />
            ))}
          </div>
          <div className="bp-flechas">
            <button
              className="bp-flecha"
              onClick={() => ir((idx - 1 + items.length) % items.length)}
              aria-label="Anterior"
            >‹</button>
            <button
              className="bp-flecha"
              onClick={() => ir((idx + 1) % items.length)}
              aria-label="Siguiente"
            >›</button>
          </div>
        </>
      )}
    </div>
  );
}
